module.exports = __webpack_public_path__ + "static/DangalPlay-a37e2927d366d656300e890b24d0a9fc.jpg";